import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Github, ArrowRight } from 'lucide-react';
import { portfolioData } from '../data/portfolio';

const FeaturedProjects = () => {
  const featuredProjects = portfolioData.projects.filter(p => p.featured);

  return (
    <section id="projects" className="py-20 md:py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Featured Projects</h2>
          <div className="w-20 h-1 bg-[#00b4d8] mb-4"></div>
          <p className="text-[#a0a0a0]">A selection of my most impactful work</p>
        </div>

        {/* Featured Projects Grid - 3 columns */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {featuredProjects.map((project, index) => (
            <div
              key={index}
              className="bg-[#151515] border border-white/10 rounded-lg overflow-hidden hover:border-[#00b4d8] transition-all duration-300 group"
            >
              <div className="aspect-video bg-[#1a1a1a] overflow-hidden">
                <img
                  src={project.imageUrl}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="p-5">
                <div className="flex items-center justify-end gap-3 mb-3">
                  {/* <span className="text-xs font-semibold text-[#00b4d8] uppercase tracking-wider">
                    {project.category === 'data' ? 'Data Analytics' : 'Program Management'}
                  </span> */}
                  {/* <ExternalLink size={16} className="text-[#666666] group-hover:text-[#00b4d8] transition-colors" /> */}
                  {project.githubLink && (
                    <a
                      href={project.githubLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#666666] hover:text-[#00b4d8] transition-colors"
                    >
                      <Github size={16} />
                    </a>
                    )}

                    {project.liveLink && (
                      <a
                        href={project.liveLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#666666] hover:text-[#00b4d8] transition-colors"
                      >
                        <ExternalLink size={16} />
                      </a>
                    )}
                </div>

                <h3 className="text-lg font-semibold mb-2 group-hover:text-[#00b4d8] transition-colors line-clamp-2">
                  {project.title}
                </h3>

                <p className="text-sm text-[#a0a0a0] mb-4 leading-relaxed line-clamp-3">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.slice(0, 3).map((tech, idx) => (
                    <span
                      key={idx}
                      className="text-xs bg-[#0a0a0a] text-[#a0a0a0] px-2 py-1 rounded-full border border-white/10"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                {/* <div className="pt-3 border-t border-white/10">
                  <p className="text-xs text-[#00b4d8] font-medium">
                    {project.impact}
                  </p>
                </div> */}
              </div>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <div className="text-center">
          <Link
            to="/projects"
            className="inline-flex items-center gap-2 bg-transparent border-2 border-[#00b4d8] text-[#00b4d8] px-8 py-4 rounded-lg font-semibold hover:bg-[#00b4d8] hover:text-white transition-all duration-300"
          >
            View All Projects
            <ArrowRight size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
